import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { graphql, Link, useStaticQuery } from "gatsby";

import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import AboutTeam from "/src/components/About/AboutTeam";
import AboutValues from "/src/components/About/AboutValues";

import "/src/css/about.css";

import AboutVision from "/src/components/About/AboutVision";

const AboutPage = () => {
  const data = useStaticQuery(query).allContentfulAdmin.nodes[0];
  const {
    ourStory: { ourStory },
    mgoriumImpactOurImpactText: { mgoriumImpactOurImpactText },
    mgoriumImpactOurVisionText: { mgoriumImpactOurVisionText },
    mgoriumOurImpactText: { mgoriumOurImpactText },
    mgoriumOurVisionText: { mgoriumOurVisionText },
    recyclingMadeSimpleText: { recyclingMadeSimpleText },
    redefiningTheFutureText: { redefiningTheFutureText },
    refiningCircularEconomiesText: { refiningCircularEconomiesText },
  } = data;

  return (
    <div className="about-page">
      <Seo title="About" />
      <div className="about-topsection">
        <StaticImage
          placeholder="tracedSVG"
          alt="A healthy Earth"
          src="../images/about-top.png"
          imgClassName="about-topsection-image"
          className="about-topsection-imagecontainer"
        />
        <div className="about-topsection-text">
          <h2 className="about-top-line1">Breathing Life</h2>
          <h2 className="about-top-line2">Into Recycled Plastic</h2>
          <p>Plastic recycling made meaningful. From waste to progress.</p>
        </div>
      </div>
      <div className="about-story">
        <h1>Our Story</h1>
        <p>{ourStory}</p>
      </div>

      <div className="about-values">
        <AboutValues
          recyclingMadeSimpleText={recyclingMadeSimpleText}
          redefiningTheFutureText={redefiningTheFutureText}
          refiningCircularEconomiesText={refiningCircularEconomiesText}
        />
      </div>

      <div className="about-vision">
        <AboutVision
          mgoriumImpactOurImpactText={mgoriumImpactOurImpactText}
          mgoriumImpactOurVisionText={mgoriumImpactOurVisionText}
          mgoriumOurImpactText={mgoriumOurImpactText}
          mgoriumOurVisionText={mgoriumOurVisionText}
        />
      </div>

      <div className="about-team">
        <h1>Our Team</h1>
        <AboutTeam />
      </div>
      <div className="about-signup">
        <Link to="/volunteer">
          <div className="about-signup-btn">
            <h3>Join Us Today!</h3>
            <StaticImage
              placeholder="tracedSVG"
              alt="A healthy Earth"
              src="../images/about-kittyhero.png"
              height={80}
              className="about-signup-img"
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

export const query = graphql`
  {
    allContentfulAdmin(limit: 1) {
      nodes {
        mgoriumImpactOurImpactText {
          mgoriumImpactOurImpactText
        }
        mgoriumImpactOurVisionText {
          mgoriumImpactOurVisionText
        }
        mgoriumOurImpactText {
          mgoriumOurImpactText
        }
        mgoriumOurVisionText {
          mgoriumOurVisionText
        }
        ourStory {
          ourStory
        }
        recyclingMadeSimpleText {
          recyclingMadeSimpleText
        }
        redefiningTheFutureText {
          redefiningTheFutureText
        }
        refiningCircularEconomiesText {
          refiningCircularEconomiesText
        }
      }
    }
  }
`;

AboutPage.Layout = Layout;
export default AboutPage;
